import { Injectable } from '@angular/core';
import NetworkTest, { ErrorNames } from 'opentok-network-test-js';
import { BehaviorSubject, Observable } from 'rxjs';
import { ApiTokboxService } from '.';
import { ApiConectateService } from '../apiConectate';
import { ApiTunningService } from '../apiTunning';
import { EnvironmentService } from '../../services/enviroment/environment.service';
import { StateHandlerService } from '../../services/state-handler/state-handler.service';
import { SessionStorageService } from '../../services/session-storage/session-storage.service';
import { UtilsService } from '../../services/utils/utils.service';
import { environment } from '../../../environments/environment';

declare var OT: any;

@Injectable({
  providedIn: "root",
})
export class ApiTokboxNetworkTestService {
  TEST_DURATION = 4000;
  ATTEMPS = 2;
  attempCounter = 1;
  otNetworkTest: any;
  audioOnly: any;
  dualCam: boolean = false;
  /**
   * BS para abrir el modal q el micro o cámara está usado por otro programa
   */
  private dualCamObs: BehaviorSubject<boolean> = new BehaviorSubject(false);
  public dualCamObs$: Observable<boolean> = this.dualCamObs.asObservable();
  /**
   * BS para informar si hay error de audio y video
   * TODO : Si se quiere habilitar el modal con recarga de página
   * q está en mutua-network-test (descomentar tmb para ello la parte de código de dicho componente)
   */
  // private isMediaErrorBS: BehaviorSubject<OTError> = new BehaviorSubject({
  //   name: '',
  //   message: ''
  // });
  // public isMediaError$: Observable<OTError> =
  //   this.isMediaErrorBS.asObservable();

  private session: any;
  private sessionInfo: any;
  public networkTestCredentials = {
    sessionId: "",
    token: "",
  };

  constructor(
    private readonly environmentService: EnvironmentService,
    private readonly stateHandlerSrv: StateHandlerService,
    private readonly sessionStorageSrv: SessionStorageService,
    private readonly apiConectateSvc: ApiConectateService,
    private readonly apiTokBoxSvc: ApiTokboxService,
    private readonly utilsService: UtilsService,
    private readonly apiTunningService: ApiTunningService
  ) {}

  resetTestBeforeRefreshPageEvent() {
    window.addEventListener("beforeunload", () => {
      console.log(
        "ApiTest resetTestBeforeRefreshPageEvent addEventListener(beforeunload) (" +
          this.utilsService.getTodayWithHour() +
          ")."
      );
      this.sessionStorageSrv.set("networkTest", false);
    });
  }

  getNetWorkTestCredentials(attendantId?:string): Observable<Object> {
    return this.apiConectateSvc.getConnectionTestToken(attendantId);
  }

  connectToTesting(sessionId: any, token: any) {
    const roomData = {
      roomTitle: "",
      attendantName: "",
      providedId: sessionId,
      attendantNames: [],
      token: token,
    };
    console.log(
      "ApiTest initSession (" + this.utilsService.getTodayWithHour() + "): ",
      roomData
    );
    this.apiTokBoxSvc
      .initSession(roomData)
      .then(() =>
        this.apiTokBoxSvc.connect().then((session) => {
          console.log(
            "ApiTest initSession then (" +
              this.utilsService.getTodayWithHour() +
              ")",
            session
          );

          this.session = session;
          if(!environment.isPatient){
            this.apiTunningService._connectionId = this.session.id;
          }
          this.startTest();
        })
      )
      .catch((err) => {
        console.error(
          "initSession error (" + this.utilsService.getTodayWithHour() + "): ",
          err
        );
        console.log(
          "Unable to connect. Make sure you have updated the config.ts file with your OpenTok details."
        );
      });
  }

  getOtNetWorkObject() {
    const duration =
      this.environmentService.data?.someParams?.durantionNetworkTest;
    this.TEST_DURATION = duration ? duration : this.TEST_DURATION;
    this.sessionInfo = {
      apiKey: this.environmentService.data?.tokbox?.API_KEY,
      sessionId: this.networkTestCredentials.sessionId,
      token: this.networkTestCredentials.token,
    };
    const options = {
      audioOnly: false,
      timeout: this.TEST_DURATION,
    };

    return new NetworkTest(OT, this.sessionInfo, options);
  }

  startTest() {
    this.otNetworkTest = this.getOtNetWorkObject();
    this.otNetworkTest
      .testConnectivity((results: any) => {
        console.error(
          "ApiTest testConnectivity startTest results: (" +
            this.utilsService.getTodayWithHour() +
            "):",
          results
        );
        this.testConnectivityErrors(results);
      })
      .then(this.testQuality())
      .catch((errors: any) => {
        this.testConnectivityErrors(errors);
      });
  }

  testConnectivityErrors(errors: any) {
    console.error(
      "testConnectivity errors (" +
        this.utilsService.getTodayWithHour() +
        "): ",
      errors
    );

    errors.failedTests &&
      errors.failedTests.forEach((error: any) => {
        switch (error?.failedTests?.error?.name) {
          case ErrorNames.FAILED_TO_OBTAIN_MEDIA_DEVICES:
            // Display UI message about granting access to the microphone and camera
            break;
          case ErrorNames.NO_AUDIO_CAPTURE_DEVICES:
          case ErrorNames.NO_VIDEO_CAPTURE_DEVICES:
            // Display UI message about no available camera or microphone
            break;
          // Handle other errors, as needed
          default:
            console.error("Unknown error .");
        }
      });
  }

  testQuality() {
    this.otNetworkTest
      .testQuality((stats: any) => {
        console.log(
          "testQuality stats (" + this.utilsService.getTodayWithHour() + "): ",
          stats
        );
      })
      .then((results: any) => {
        this.otNetworkTest.stop();
        this.session.disconnect();
        this.finishTest(results);
        console.log(
          "testQuality results (" +
            this.utilsService.getTodayWithHour() +
            "): ",
          results
        ); // const audioMos = results.audio.mos;
      })
      .catch((error: any) => {
        console.log(
          "testQuality error (" + this.utilsService.getTodayWithHour() + "): ",
          error
        );

        switch (error.name) {
          case ErrorNames.UNSUPPORTED_BROWSER:
            // Display UI message about unsupported browser
            break;
          case ErrorNames.CONNECT_TO_SESSION_NETWORK_ERROR:
            // Display UI message about network error
            break;
          case ErrorNames.FAILED_TO_OBTAIN_MEDIA_DEVICES:
            // Display UI message about granting access to the microphone and camera
            break;
          case ErrorNames.NO_AUDIO_CAPTURE_DEVICES:
            // Display UI message about no available camera or microphone
            // Descomentar para q aparezca el modal con botón de recarga
            // y comentar dualCamObs (cambiar un modal por otro)
            // this.isMediaErrorBS.next(error);
            this.dualCamObs.next(true);
            break;
          case ErrorNames.INIT_PUBLISHER_ERROR:
            this.dualCamObs.next(true);
            break;
          case ErrorNames.NO_VIDEO_CAPTURE_DEVICES:
            this.dualCamObs.next(true);
            break;
          case ErrorNames.PUBLISH_TO_SESSION_ERROR:
            this.dualCamObs.next(true);
            break;
          default:
            console.error(
              "Unknown error " + this.utilsService.getTodayWithHour() + ". "
            );
            window.location.reload();
            break;
        }

        // this.reloadTest();
      });
  }

  reloadTest() {
    let attempCounter = this.sessionStorageSrv.get("netWorkTestAttempCounter");
    console.log(
      "ApiTest reloadTest attempCounter (" +
        this.utilsService.getTodayWithHour() +
        "): ",
      attempCounter
    );
    attempCounter = !attempCounter ? 0 : attempCounter;

    // Repeat networkTest disabled (problem of unnecessary loops)
    if (++attempCounter < this.ATTEMPS) {
      this.sessionStorageSrv.set("netWorkTestAttempCounter", attempCounter);
      console.log(
        "ApiTest reloadTest reload page (" +
          this.utilsService.getTodayWithHour() +
          "). "
      );
      window.location.reload();
    } else {
      this.sessionStorageSrv.set("netWorkTestAttempCounter", false);
    }
  }

  finishTest(results: any) {
    let attempCounter = this.sessionStorageSrv.get("netWorkTestAttempCounter");
    attempCounter = !attempCounter ? 0 : attempCounter;

    if (++attempCounter < this.ATTEMPS) {
      results = this.parseSupportedField(results);
      this.sessionStorageSrv.set("netWorkTestAttempCounter", attempCounter);
      const audioTest = results?.audio?.supported;
      const videoTest = results?.video?.supported;

      if (!(audioTest && videoTest)) {
        console.log(
          "ApiTest finishTest reload page " +
            this.utilsService.getTodayWithHour() +
            ". "
        );
        window.location.reload();
      } else {
        this.stateHandlerSrv.set("connectivity_test", results, false);
        this.sessionStorageSrv.set("netWorkTestAttempCounter", false);
      }
    } else {
      console.log(
        "ApiTest session.off() " + this.utilsService.getTodayWithHour() + ". "
      );
      this.session.off();
      this.session.disconnect();
      this.stateHandlerSrv.set("connectivity_test", results, false);
      this.sessionStorageSrv.set("netWorkTestAttempCounter", false);
    }
  }
  /**
   * https://support.tokbox.com/hc/en-us/articles/360029732311-What-is-the-minimum-bandwidth-requirement-to-use-the-Vonage-Video-API-
   * @param results
   * @returns results
   */
  parseSupportedField(results: any): any {
    /**
     * Supported from mos values
     *
     */
    const minMosRequiredNetworkTest =
      this.environmentService.data?.someParams?.minMosRequiredNetworkTest;
    const videoMosMinValue = minMosRequiredNetworkTest
      ? minMosRequiredNetworkTest
      : 1.7;
    results.video.supportedByOpentok = results.video.supported;
    results.video.supported =
      results.video.mos >= videoMosMinValue ? true : false;

    /**
     * Supported from bitrate values
     * 
    const recommendedResolution = results?.video?.recommendedResolution;

    if (results?.video) {
      const bitrate = results.video.bitrate / 1000; // bps -> kbps

      if (recommendedResolution === '320x240') {
        results.video.supported = bitrate > 150 ? true : false;

      } else if (recommendedResolution === '640x480') {
        results.video.supported = bitrate> 250 ? true : false;

      } else {
        results.video.supported = bitrate > 350 ? true : false;
      }
    }

    if (results?.audio) {
      results.audio.supported = results.audio.bitrate > 25 ? true : false;
    }
     */

    return results;
  }
}
